import ChessRestClient from '@/Api/ChessRestClient';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useNotificationStore} from '@/Store/useNotificationStore';

export default function useGetMessagesApi(
  channel_id: number,
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const query = useQuery({
    queryKey: ['messages', channel_id],
    queryFn: async () => {
      if (!channel_id) throw new Error('channel_id is required');

      // for now you only pass channel_id
      const url = `/inbox/get_messages/${channel_id}`;

      // Example (real endpoint):
      // const url = `/inbox/get_messages/${channel_id}`;

      const response = await ChessRestClient.get(url);
      return response?.data ?? [];
    },
    
    enabled: !!channel_id, // only run if channel_id is valid
    onSuccess: data => {
      useNotificationStore.getState().markInboxChannelRead(channel_id);
      handleOnSuccess?.(data);
    },
    onError: error => handleOnError?.(error),
    structuralSharing: false, 
  });

  const qc = useQueryClient()
  const refetchForChannel = (id: number) =>
    qc.refetchQueries({ queryKey: ['messages', id], exact: true })

  return {
    ...query, // gives you data, isLoading, isError, refetch, etc.
    refetchForChannel
  };
}
